import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IQueryParams } from '../../../control-plane/models/common/IQueryParams';
import { defaultJourneyListStatus } from './Utility';
import { SORT_STRINGS } from '../../../control-plane/constants';

/**
 * Initial All Event state in store
 */

export interface IJourneyFilterState extends IQueryParams {
  sort: string;
}

export interface IFilterJourneyPayload {
  searchText: string;
  status: string;
  toDate: Date | null | string;
  fromDate: Date | null | string;
}

const initialState: IJourneyFilterState = {
  searchText: '',
  status: defaultJourneyListStatus,
  toDate: null,
  fromDate: null,
  sort: SORT_STRINGS.LAST_MODIFIED,
};

const filterJourneySlice = createSlice({
  name: 'filterJourney',
  initialState,
  reducers: {
    addFilterJourneyData: (state, action: PayloadAction<IFilterJourneyPayload>) => {
      state.searchText = action.payload.searchText;
      state.status = action.payload.status;
      state.toDate = action.payload.toDate;
      state.fromDate = action.payload.fromDate;
    },
    addSortJourneyData: (state, action: PayloadAction<string>) => {
      state.sort = action.payload;
    },
    clearFilterJourney: (state) => {
      state.status = '';
      state.toDate = null;
      state.fromDate = null;
      state.sort = '';
    },
    clearQueryParamJourney: (state) => {
      state.searchText = '';
      state.status = '';
      state.toDate = null;
      state.fromDate = null;
      state.sort = '';
    },
  }
});
export const {
  addFilterJourneyData,
  clearFilterJourney,
  addSortJourneyData,
  clearQueryParamJourney
} = filterJourneySlice.actions;
export default filterJourneySlice.reducer;
